"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProgramItem = require("./ProgramItem");
Object.keys(_ProgramItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProgramItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProgramItem[key];
    }
  });
});